import React, { memo } from 'react'

import { func } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import UpgradeCard from '../UpgradeCard/UpgradeCard'

function HasCreditsBody({ onClose: handleClose }) {
  const availableCredits = useThreeDStudioStore(state => state.generation.availableCredits) || 0
  const label = availableCredits === 1 ? 'credit' : 'credits'

  return (
    <div className="usage-modal__has-credits">
      <p className="usage-modal__headline cgt-heading-200">
        {`You have ${availableCredits} ${label} left`}
      </p>

      <UpgradeCard onClose={handleClose} />
    </div>
  )
}

HasCreditsBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(HasCreditsBody)
